import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import BrandMark from '@/components/feature/BrandMark';

interface FooterProps {
  hideCTA?: boolean;
}

export default function Footer({ hideCTA = false }: FooterProps) {
  const { t } = useTranslation();
  const { isLoggedIn, user } = useAuth();
  const hasProfile = !!(user && user.handle);

  return (
    <footer className="w-full bg-background-50 border-t border-background-200/50">
      <div className="max-w-[720px] mx-auto px-4 md:px-6 py-8 flex flex-col items-center text-center gap-5">
        {/* CTA line */}
        {!hideCTA && (
          <div>
            {!isLoggedIn ? (
              // 主动发码阶段:首页不推销邀请/候补;注册流自己会要码。页脚只留登录。
              <Link
                to="/login"
                className="text-[12px] text-foreground-400 hover:text-foreground-700 transition-colors duration-200 tracking-wide"
              >
                {t('nav.login')}
              </Link>
            ) : !hasProfile ? (
              <Link
                to="/onboarding"
                className="text-[13px] text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {t('footer.improve')}
              </Link>
            ) : (
              <Link
                to="/compose"
                className="text-[13px] text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {t('nav.post')}
              </Link>
            )}
          </div>
        )}

        {/* Signature seal */}
        <BrandMark to="/" showWordmark={false} />

        {/* Weak links */}
        <div className="flex items-center gap-4">
          <Link
            to="/about"
            className="text-[11px] text-foreground-300 hover:text-foreground-600 transition-colors duration-200"
          >
            {t('footer.about')}
          </Link>
          <span className="text-foreground-200 text-[10px]">·</span>
          <Link
            to="/guidelines"
            className="text-[11px] text-foreground-300 hover:text-foreground-600 transition-colors duration-200"
          >
            {t('footer.guidelines')}
          </Link>
          <span className="text-foreground-200 text-[10px]">·</span>
          <Link
            to="/privacy"
            className="text-[11px] text-foreground-300 hover:text-foreground-600 transition-colors duration-200"
          >
            {t('footer.privacy')}
          </Link>
          <span className="text-foreground-200 text-[10px]">·</span>
          <Link
            to="/terms"
            className="text-[11px] text-foreground-300 hover:text-foreground-600 transition-colors duration-200"
          >
            {t('footer.terms')}
          </Link>
          <span className="text-foreground-200 text-[10px]">·</span>
          <a
            href="mailto:report@dev.cx?subject=%5Breport%5D"
            className="text-[11px] text-foreground-300 hover:text-foreground-600 transition-colors duration-200"
          >
            {t('footer.report')}
          </a>
          <span className="text-foreground-200 text-[10px]">·</span>
          <span className="text-[11px] text-foreground-300">
            dev.cx &copy; {new Date().getFullYear()}
          </span>
        </div>
      </div>
    </footer>
  );
}
